const config = {
  id: process.env.REACT_APP_GA_MEASUREMENT_ID,
}

export { config }
